import React from 'react';
import { BadgeCheck } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

/**
 * Compact "Verified Host" badge shown when the host's PAN has been verified
 * against Income Tax Department records via Sandbox.co.in.
 *
 * Props:
 *  - size: 'sm' (card chips) | 'md' (detail page) | 'lg' (full host block)
 *  - showLabel: whether to display the text label next to the icon
 */
const VerifiedHostBadge = ({ size = 'sm', showLabel = true, className = '' }) => {
  const sizes = {
    sm: { icon: 'h-3.5 w-3.5', text: 'text-[11px]', padding: 'px-1.5 py-0.5' },
    md: { icon: 'h-4 w-4', text: 'text-xs', padding: 'px-2 py-1' },
    lg: { icon: 'h-5 w-5', text: 'text-sm', padding: 'px-2.5 py-1' },
  };
  const s = sizes[size] || sizes.sm;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid="verified-host-badge"
            onClick={(e) => e.stopPropagation()}
            className={`inline-flex items-center gap-1 rounded-full bg-green-50 text-green-700 border border-green-200 font-medium ${s.padding} ${s.text} ${className}`}
          >
            <BadgeCheck className={`${s.icon} fill-green-600 text-white`} strokeWidth={2.5} />
            {showLabel && <span>Verified Host</span>}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <p className="text-xs">
            Host identity verified against Income Tax Department records (PAN KYC).
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default VerifiedHostBadge;
